import { useMemo } from "react";
import { columnTypesBoolean } from "../columnTypesBoolean";
import { columnTypesDate } from "../columnTypesDate";
import { columnTypesDollar } from "../columnTypesDollar";
import { columnTypesPercent } from "../columnTypesPercent";

export const useColumnTypes = (groupByCategory, editing) => {
  return useMemo(() => {
    return {
      ...columnTypesDate(),
      ...columnTypesPercent(),
      ...columnTypesDollar(),
      ...columnTypesBoolean(),
    };
  }, []);
};

/**
    const columnTypes = useColumnTypes();
*/
